export default "__VITE_ASSET__KUwW6ryw__"